import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent, cloneElement } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import VisibilityAnimation from '../VisibilityAnimation';
import { POINTS_X, POINTS_Y } from '../constants/overlay';
import { withStyles } from '../theme';
import { isolateMixin } from '../utils/mixins';
import { ios, android } from '../utils/browser';
var isMobileBehavior = ios || android;

var styles = function styles(theme) {
  return {
    hint: {
      extend: isolateMixin,
      display: 'flex',
      fontFamily: theme.fontFamily,
      position: 'relative',
      color: theme.hint.colors.text,
      borderRadius: theme.hint.borderRadius,
      boxSizing: 'border-box',
      boxShadow: theme.hint.boxShadow,
      paddingTop: theme.hint.verticalPadding,
      paddingBottom: theme.hint.verticalPadding,
      width: 265,
      backgroundColor: theme.hint.colors.background,
      fontSize: theme.hint.fontSize,
      lineHeight: theme.hint.lineHeight,
      opacity: 0.01,
      transitionDuration: "".concat(theme.hint.animationDuration, "ms"),
      transitionProperty: 'opacity',
      fontWeight: theme.hint.fontWeight
    },
    mobile: {
      width: '100%',
      maxWidth: theme.hint.maxWidth,
      padding: "".concat(theme.hint.mobile.verticalPadding, "px ").concat(theme.hint.mobile.horizontalPadding, "px"),
      fontSize: 14
    },
    arrow: {
      position: 'absolute',
      borderStyle: 'solid',
      borderColor: 'transparent',
      borderWidth: theme.hint.arrowSize,
      borderBottomColor: theme.hint.colors.background,
      zIndex: 100
    },
    isVisible: {
      opacity: 1
    },
    icon: {
      flexShrink: 0
    },
    left: {
      left: -theme.hint.horizontalPadding,
      paddingLeft: theme.hint.horizontalPadding,
      paddingRight: theme.hint.horizontalPadding,
      '& $icon': {
        marginRight: theme.hint.horizontalPadding
      }
    },
    right: {
      left: theme.hint.horizontalPadding,
      paddingLeft: theme.hint.horizontalPadding,
      paddingRight: theme.hint.horizontalPadding,
      flexDirection: 'row-reverse',
      '& $icon': {
        marginLeft: theme.hint.horizontalPadding
      }
    },
    top: {
      top: -15,
      '&$mobile': {
        top: 10
      },
      '& $arrow': {
        bottom: '100%'
      }
    },
    bottom: {
      top: 19,
      '&$mobile': {
        top: -10
      },
      '& $arrow': {
        top: '100%',
        transform: 'rotate(180deg)'
      }
    }
  };
};

var HintContent = /*#__PURE__*/function (_PureComponent) {
  _inherits(HintContent, _PureComponent);

  var _super = _createSuper(HintContent);

  function HintContent() {
    var _this;

    _classCallCheck(this, HintContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.cachedPosition = {};
    return _this;
  }

  _createClass(HintContent, [{
    key: "renderIcon",
    value: function renderIcon() {
      var _this$props = this.props,
          icon = _this$props.icon,
          classes = _this$props.classes,
          theme = _this$props.theme;
      if (isMobileBehavior) return React.createElement("div", {
        className: classes.arrow,
        style: {
          left: this.position.arrowLeft
        }
      });
      var iconProps = icon.props || {};
      return cloneElement(icon, {
        className: classnames(classes.icon, iconProps.className),
        color: iconProps.color || theme.hint.icon.colors.active
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          isVisible = _this$props2.isVisible,
          className = _this$props2.className,
          style = _this$props2.style,
          children = _this$props2.children,
          pointX = _this$props2.pointX,
          pointY = _this$props2.pointY,
          theme = _this$props2.theme,
          classes = _this$props2.classes,
          contentRef = _this$props2.contentRef,
          onMouseEnter = _this$props2.onMouseEnter,
          onMouseLeave = _this$props2.onMouseLeave,
          onBecomeVisible = _this$props2.onBecomeVisible,
          onBecomeInvisible = _this$props2.onBecomeInvisible;
      var contentStyle;
      if (isMobileBehavior) contentStyle = {
        left: this.position.contentLeft
      };
      return React.createElement(VisibilityAnimation, {
        isVisible: isVisible,
        animationDuration: theme.hint.animationDuration,
        onVisible: onBecomeVisible,
        onInvisible: onBecomeInvisible
      }, function (_ref) {
        var isVisible = _ref.isVisible;
        return React.createElement("div", {
          ref: contentRef,
          className: classnames(classes.hint, classes[isMobileBehavior ? 'mobile' : pointX], classes[pointY], className, isVisible && classes.isVisible),
          style: _extends({}, contentStyle, {}, style),
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave
        }, _this2.renderIcon(), children);
      });
    }
  }, {
    key: "position",
    get: function get() {
      var clientWidth = document.body.clientWidth;
      var _this$props3 = this.props,
          _this$props3$anchorLe = _this$props3.anchorLeft,
          anchorLeft = _this$props3$anchorLe === void 0 ? 0 : _this$props3$anchorLe,
          _this$props3$anchorWi = _this$props3.anchorWidth,
          anchorWidth = _this$props3$anchorWi === void 0 ? 0 : _this$props3$anchorWi;
      var key = "".concat(anchorLeft, "-").concat(anchorWidth, "-").concat(clientWidth);
      if (key === this.cachedPosition.key) return this.cachedPosition;
      var anchorCenterLeft = anchorLeft + anchorWidth / 2;
      var contentLeft;
      var arrowLeft;

      if (clientWidth < 480 || anchorCenterLeft < 240) {
        contentLeft = 0;
        arrowLeft = anchorCenterLeft - 5;
      } else if (anchorCenterLeft > clientWidth - 240) {
        contentLeft = clientWidth - 480;
        arrowLeft = anchorCenterLeft - 5 + 480 - clientWidth;
      } else {
        contentLeft = anchorCenterLeft - 240;
        arrowLeft = 240 - 5;
      }

      this.cachedPosition = {
        key: key,
        arrowLeft: arrowLeft,
        contentLeft: contentLeft
      };
      return this.cachedPosition;
    }
  }]);

  return HintContent;
}(PureComponent);

HintContent.defaultProps = {
  isVisible: false
};
HintContent.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  style: PropTypes.object,
  icon: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  isVisible: PropTypes.bool,
  pointX: PropTypes.oneOf(POINTS_X),
  pointY: PropTypes.oneOf(POINTS_Y),
  anchorLeft: PropTypes.number,
  anchorWidth: PropTypes.number,
  contentRef: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onBecomeVisible: PropTypes.func,
  onBecomeInvisible: PropTypes.func
} : {};
export default withStyles(styles, {
  name: 'HintContent'
})(HintContent);